<template>
  <div>
    <div class="page-title">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">考試</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mt-1 mb-3">
      <live-player :liveData="exam" v-if="exam && !isFinish" v-on:finish="finish" />

      <div class="exam-result bg-white mt-5 mb-3" v-else>
        <div v-if="score">
          <p v-for="(section, index) in score.sectionResults" :key="index">您的 {{ section.name }} 得分：{{ section.score }}</p>
          <hr>
          您的考試總分：{{ score.totalScore }}<br>
        </div>

        <div v-else>
          您尚未完成這份考卷
        </div>

        <button class="btn btn-success btn-block w-25 mx-auto" style="margin-top: 4.5em;" @click.stop.prevent="$router.go(-1)">返回</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LivePlayer from '../components/live-player/components/Exam.vue'
import langMixins from '../components/langMixin'
// import LivePlayer from 'live-player/dist/LivePlayer.js'
import api from '../store/api'

export default {

  name: 'ExamPlayer',

  components: {
    LivePlayer
  },

  mixins: [langMixins],

  data () {
    return {
      isFinish: false,
      score: null
    }
  },

  computed: {
    ...mapGetters([
      'exam'
    ])
  },

  mounted () {
    if (this.$route.name === 'quiz.start') {
      this.getAssessmentData()
    } else {
      this.getExamData()
    }
  },

  beforeDestroy () {
    clearInterval(this.recordTimer)
    this.recordTimer = null
  },

  methods: {
    ...mapActions([
      'getExam'
    ]),

    async getExamData () {
      let examId = this.$route.params.examId
      await this.getExam(examId)
    },

    async getAssessmentData () {
      await this.getExam('Assessment')
    },

    async finish (recordId) {
      const { data } = await api.post('/Exam/' + recordId + '/Finish')
      if (data.status === 'OK') {
        this.score = data.data

        this.isFinish = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-result {
  line-height: 2.2em;
  font-size: 2em;
  padding: 4em;
  letter-spacing: 0.1em;
}
</style>



// WEBPACK FOOTER //
// ExamPlayer.vue?49bb31f7